import * as React from 'react';
import { LoadStatus } from './App';
import IconInfo from './IconInfo';
import MapInfo from './MapInfo';
import DriverInfo from './DriverInfo';
import StatusBar from './StatusBar';
import { OS } from './App';
import * as moment from 'moment';
import TimeOptions from './TimeOptions';

interface OrderCardProps {
  style?: any; // tslint:disable-line
  loadStatus: LoadStatus;
  order: models.Order | undefined;
  lang: string;
  os: OS;
  onLangChange: (lang: string) => void;
}

class OrderCard extends React.Component<OrderCardProps, {}> {

  render() {

    let styles = {
      card: {
        flex: '1 1 100%',
        display: 'flex',
      },
      loading: {
        width: '240px',
        height: '240px',
        margin: 'auto',
        overflow: 'hidden' as 'hidden'
      },
      map: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column' as 'column'
      }
    };

    let card: JSX.Element;
    if (this.props.loadStatus === LoadStatus.Processing) {
      card = (
        <div style={styles.loading}>
          <div className="loader">
            Loading...
          </div>
        </div>
      );
    } else if (this.props.loadStatus === LoadStatus.NotFound) {
      card = (
        <div style={{ margin: 'auto 0' }}>
          <IconInfo id="errorIcon" icon="notfound" />
        </div>
      );
    } else if (this.props.loadStatus === LoadStatus.Error || !this.props.order) {
      card = (
        <div style={{ margin: 'auto 0' }}>
          <IconInfo id="errorIcon" icon="error" />
        </div>
      );
    } else {
      let info: JSX.Element;
      switch (this.props.order.status) {
        case 'PROCESSING':
          info = <IconInfo id="statusIcon" icon="search" />;
          break;
        case 'ACCEPTED':
        case 'IN_PROGRESS':
        case 'ARRIVED':
          info = <DriverInfo order={this.props.order} />;
          break;
        case 'COMPLETED':
          info = <IconInfo id="statusIcon" icon="closed" />;
          break;
        default:
          info = <IconInfo id="statusIcon" icon="canceled" />;
      }

      let timeOption: JSX.Element | undefined;
      if (this.props.order && this.props.order.time) {
        let timeStr = moment(this.props.order.time).calendar();
        timeOption = <TimeOptions time={timeStr} />;
      }
  
      card = (
        <div id="orderCard" style={styles.card}>
          <div style={styles.map}>
            <StatusBar lang={this.props.lang} os={this.props.os} onLangChange={this.props.onLangChange} />
            <MapInfo order={this.props.order}>
              {timeOption}
            </MapInfo>
          </div>
          {info}
        </div>
      );
    }

    return card;
  }
}

export default OrderCard;



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/OrderCard.tsx